<template>
  <el-dialog
    class="spring-festival-gift-list-dialog"
    :visible.sync="visible"
    :show-close="false"
    :append-to-body="true"
    top="10vh"
  >
    <img class="prize-header" src="./images/prize-header.png" alt="" />

    <!-- <img
        class="close"
        src="./images/close.png"
        alt=""
        @click="closeDialog()"
      /> -->
    <ul class="gift-list">
      <li class="gift-list-item header">
        <span class="icon"></span>
        <span class="name">物品名稱</span>
        <span class="count">數量</span>
      </li>
      <li v-for="(item, index) of list" :key="index" class="gift-list-item">
        <img class="icon" :src="item.src" alt="" />
        <span class="name">{{ item.iconName }}</span>
        <span class="count">{{ item.count }}{{ item.unit }}</span>
      </li>
    </ul>
  </el-dialog>
</template>
<script>
import answerTickets from './images/answer-tickets.png';
import bag from './images/bag.png';
import gift from './images/gift.png';
import nicee1 from './images/nicee.png';
import nicee2 from './images/nicee-2.png';
import nicee3 from './images/nicee-3.png';
import diamond from './images/diamond.png';
import diamond2 from './images/diamond-2.png';
import diamond3 from './images/diamond-3.png';
export default {
  name: 'GiftList',
  props: {
    activityData: {
      typeof: Object,
      default: () => {
        return {};
      }
    }
    //   //   120 天使
    //   //   102 黃金箱子
    //   //   133 應援票
    // }
  },
  data() {
    return {
      visible: false
    };
  },
  watch: {},
  computed: {
    list() {
      try {
        return [
          {
            src: diamond,
            iconName: '鑽石*1000',
            count: this.activityData.appendInfo.lotteryLogs['P01'] || 0,
            unit: '份'
          },
          {
            src: diamond2,
            iconName: '鑽石*1200',
            count: this.activityData.appendInfo.lotteryLogs['P02'] || 0,
            unit: '份'
          },
          {
            src: diamond3,
            iconName: '鑽石*2000',
            count: this.activityData.appendInfo.lotteryLogs['P03'] || 0,
            unit: '份'
          },
          {
            src: nicee1,
            iconName: 'nicee幣*66',
            count: this.activityData.appendInfo.lotteryLogs['P04'] || 0,
            unit: '份'
          },
          {
            src: nicee2,
            iconName: 'nicee幣*288',
            count: this.activityData.appendInfo.lotteryLogs['P05'] || 0,
            unit: '份'
          },
          {
            src: bag,
            iconName: '黃金箱子',
            count: this.activityData.appendInfo.lotteryLogs['P06'] || 0,
            unit: '個'
          },
          {
            src: gift,
            iconName: '天使',
            count: this.activityData.appendInfo.lotteryLogs['P07'] || 0,
            unit: '個'
          },
          {
            src: answerTickets,
            iconName: '應援票',
            count: this.activityData.appendInfo.lotteryLogs['P08'] || 0,
            unit: '張'
          },
          {
            src: nicee3,
            iconName: 'nicee幣*1000',
            count: this.activityData.appendInfo.lotteryLogs['P09'] || 0,
            unit: '份'
          }
        ];
      } catch (error) {
        return [
          {
            src: diamond,
            iconName: '鑽石*1000',
            count: 0,
            unit: '份'
          },
          {
            src: diamond2,
            iconName: '鑽石*1200',
            count: 0,
            unit: '份'
          },
          {
            src: diamond3,
            iconName: '鑽石*2000',
            count: 0,
            unit: '份'
          },
          {
            src: nicee1,
            iconName: 'nicee幣*66',
            count: 0,
            unit: '份'
          },
          {
            src: nicee2,
            iconName: 'nicee幣*288',
            count: 0,
            unit: '份'
          },
          {
            src: bag,
            iconName: '黃金箱子',
            count: 0,
            unit: '個'
          },
          {
            src: gift,
            iconName: '天使',
            count: 0,
            unit: '個'
          },
          {
            src: answerTickets,
            iconName: '應援票',
            count: 0,
            unit: '張'
          },
          {
            src: nicee3,
            iconName: 'nicee幣*1000',
            count: 0,
            unit: '份'
          }
        ];
      }
    }
  },
  methods: {
    openDialog() {
      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss">
.spring-festival-gift-list-dialog {
  padding-top: 0;
  overflow: auto;
  .el-dialog {
    background-color: #8b4800;
    width: 383px;
    // height: 514px;
    border-radius: 13px;
  }
  .el-dialog__body {
    padding: 0 !important;
  }
  // background-color: #793f00;
  //   height: 771px;
  // width: 575px;
  border: 2px solid rgba(252, 210, 64, 0.94);
  .el-dialog__content {
    padding: 0;
  }
  .el-dialog__footer {
    display: none;
  }
  .gift-list {
    padding-bottom: 20px;
  }

  .gift-list-item {
    text-align: center;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #fde386;
    height: 45px;
    background-color: #8b4800;
    // border-bottom:1px solid #793F00;
    .icon {
      width: 40px;
      height: 40px;
      margin-left: 33px;
      margin-right: 12px;
      flex: none;
    }
    .name {
      width: 20rem;
    }
    .count {
      flex: auto;
    }
    &.header {
      background-color: #fcd240;
      height: 40px;
      margin-top: 40px;
      color: #8b4800;
      margin-bottom: 10px;
    }
  }
  .prize-header {
    width: 250px;
    // height: 106px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
